<template>
  <div class="home-view">
    <div class="soda-toolbar white primary--text">
      <div class="hidden-sm-and-down">
        <v-row no-gutters align="center">
          <v-col cols="3">
            <v-img
              :src="require('@/assets/logo_soda_default.png')"
              contain
              height="70px"
              class="my-2"
              style="cursor:pointer"
              @click="to_home()"
            ></v-img>
          </v-col>
          <v-col cols="9" align="right" class="hidden-sm-and-down">
            <!--<span><v-btn class="primary--text" text @click="to_features()">Funktionen</v-btn></span>
            <span>|</span>-->
            <span><v-btn class="primary--text" text @click="to_plans()">Preise</v-btn></span>
            <span>|</span>
            <span><v-btn class="primary--text" text @click="onLogin()">zur App</v-btn></span>
            <span>
              <v-btn class="primary--text secondary mr-12" rounded outlined @click="onSignup()">
              <v-icon class="mr-2">mdi-play</v-icon> Jetzt loslegen</v-btn>
            </span>
            <!-- mdi-menu-right mdi-chevron-right -->
          </v-col>
        </v-row>
      </div>
      <div class="hidden-md-and-up">
        <v-toolbar flat>
          <img class="mr-3" :src="require('@/assets/logo_soda_default.png')" height="40" @click="to_home()"/>
          <v-spacer></v-spacer>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                depressed 
                color="white" 
                fab 
                align="right" 
                slot="activator"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </template>            
            <v-list>
              <v-list-item key="to_plans" @click="to_plans()">                
                  <v-list-item-title>PREISE</v-list-item-title>
              </v-list-item>
              <v-list-item key="onLogin" @click="onLogin()">                
                  <v-list-item-title>ZUR APP</v-list-item-title>
              </v-list-item>
              <v-list-item key="onSignup" @click="onSignup()" style="background-color:var(--v-secondary-base)">     
                  <v-list-item-icon><v-icon>mdi-play</v-icon></v-list-item-icon>         
                  <v-list-item-title>JETZT LOSLEGEN</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </div>
    </div>
    <div v-if="show_main" class="mb-12">
      <div class="hidden-sm-and-down">
        <div id="wall01" class="secondary" style="overflow:auto">
          <div style="width:60%;float:right;">
            <v-img :aspect-ratio="16 / 7" :src="require('@/assets/landing_blue.jpg')"> </v-img>
          </div>
          <div style="width:40%;">
            <v-row align="end" class="lightbox pa-2 fill-height">
              <v-col>
                <div class="mt-12 ml-4 primary--text title">Einfach. Sicher. Online.</div>
                <div class="ml-8 white--text display-2">Mit zwei Klicks</div>
                <div class="ml-12 white--text display-2">zum Datenschutz.</div>
                <div class="mr-4 primary--text body-1" style="float:right">DSGVO Dokumentation für alle.</div>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
      <div class="hidden-md-and-up">
        <div id="wall01" class="secondary" style="overflow:auto">
          <div>
            <div class="mt-4 ml-4 white--text title" style="float:left; position:absolute;z-index:10"><p>Einfach.<br/>Sicher.<br/>Online.</p></div>
            <v-img :aspect-ratio="16 / 7" :src="require('@/assets/landing_blue.jpg')"/>
          </div>
          <div class="ma-2">
            <!--<v-row align="end" class="lightbox pa-2 fill-height">
              <v-col>-->
                <div class="ml-2 white--text text-h5">Mit zwei Klicks zum Datenschutz.</div>
                <div class="mr-4 primary--text body-1" style="float:right">DSGVO Dokumentation für alle.</div>
              <!--</v-col>
            </v-row>-->
          </div>
        </div>
      </div>
      <v-row class="ml-4">
        <v-col cols="12">
          <v-row>
            <v-col>
              <div class="grey--text display-1">Sparen Sie 70% Ihrer Zeit!</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="mr-4 primary--text body-1">
                <p>Das Verzeichnis aller Verarbeitungstätigkeiten (ehemals Verfahrensverzeichnis) nach Artikel 30 DSGVO stellt Unternehmen, Vereine und Steuerberater vor große Herausforderungen.</p>
                <p>Datenschutzbeauftragte sparen mit SODA bis zu 70% Ihrer Zeit für Vorbereitung, Durchführung und Nachbereitung eines Audits mit Ihren Kunden. Zentraler Bestandteil dabei ist die DSGVO konforme vollständige Dokumentation und Pflege des Verzeichnis aller Verarbeitungstätigkeiten.</p>
                <p>Sowohl für Datenschutzbeauftragte, als auch für kleine und mittelständische Unternehmen (KMU) ist SODA die natürlich Ergänzung zu einem rechtssicheren Datenschutzmanagement.</p>
              </div>
            </v-col>
          </v-row>
          <div style="margin-bottom:30px">
            <v-btn class="primary--text secondary mr-12" outlined @click="onSignup()"
              >kostenlos Testen</v-btn
            >
          </div>
        </v-col>
      </v-row>

      <div style="background-color:var(--v-secondary-base); padding:20px">
        <v-container>
          <v-row>
              <v-col align="center">
                <div class="white--text display-1" style="margin-bottom:20px">SODA? Was kann die Software?</div>
              </v-col>
          </v-row>
        </v-container>
        <v-container fluid>
          <v-row>
            <v-col v-for="feature in features" :key="feature.title" :cols="$mq | mq({lg:3, md:6, sm:12})" class="d-flex flex-columns">
              <v-card class="mx-auto flex d-flex flex-column">
                <div align="center">
                  <v-icon color="primary" size="60" style="margin:20px">{{feature.icon}}</v-icon>
                </div>
                <v-card-title v-text="feature.title">
                </v-card-title>
                <v-card-text  v-text="feature.text" class="flex">
                </v-card-text>
              </v-card>
            </v-col>
         </v-row>
        </v-container>
      </div>

      <div class="intro-video-section" align="center">
        <v-container>
          <v-row>
            <v-col>
              <div class="display-1" style="margin:20px"> In wenigen Klicks zur Dokumentation</div>
              <div class="subtitle-1" style="margin:20px">
                In unserem Video zeigen wir Ihnen, wie sie in wenigen Klicks eine komplette Datenschutzdokumentation bestehend aus VVT und TOMs sowie einem Datenschutzkonzept erstellen können.
              </div>
            </v-col>
          </v-row>
          <v-row  v-if="introVideoURL">
            <v-col>
              <div class="video-player hidden-sm-and-down">
                <video width="800" controls>
                  <source :src="introVideoURL" type="video/mp4">
                  Entschuldigung, Ihr Browser unterstützt unser Videoformat nicht.
                </video>
              </div>
              <div class="video-player-sm hidden-md-and-up">
                <video width="100%" controls>
                  <source :src="introVideoURL" type="video/mp4">
                  Entschuldigung, Ihr Browser unterstützt unser Videoformat nicht.
                </video>
              </div>
            </v-col>
          </v-row>          
        </v-container>        
      </div>

      <div class="personas-section">
        <v-container>
          <v-row>
            <v-col>
              <div align="center" class="white--text display-1" style="margin:30px">Was unsere Nutzer sagen</div>
            </v-col>
          </v-row>
          <v-row justify="space-around">
            <v-col class="d-flex flex-columns" :cols="$mq | mq({lg:4, md:6, sm:12})">
              <v-card grid-list-xl class="mx-auto flex d-flex flex-column">
                <div align="center" style="margin:10px">
                  <v-avatar
                    class="profile"
                    size="164"
                  >
                    <v-img :src="require('@/assets/Dirk_Datenschuetzer_pic.jpg')"></v-img>
                  </v-avatar>
                </div>
                <v-card-title>
                  Dirk (42) - Externer DSB
                </v-card-title>
                <v-card-text  class="flex">
                  &bdquo;Die DSGVO-Doku ist für mich und meine Kunden eine Qual. Ein einfaches Tool, das meine Audits plant, ihnen eine Struktur gibt und mit dem ich schon im Audit die Doku „live“ erledigen kann – das wär‘s! Dann könnte ich mehr Kunden annehmen, oder meine Preise senken. Oder beides...&ldquo;
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="d-flex flex-columns" :cols="$mq | mq({lg:4, md:6, sm:12})">
              <v-card grid-list-xl class="mx-auto flex d-flex flex-column">
                <div align="center" style="margin:10px">
                  <v-avatar
                    class="profile"
                    size="164"
                  >
                    <v-img :src="require('@/assets/Susanne_Steuerberaterin_pic.jpeg')"></v-img>
                  </v-avatar>
                </div>
                <v-card-title>
                  Susanne (39) - Steuerberaterin
                </v-card-title>
                <v-card-text  class="flex">
                  &bdquo;Dieser ganze Datenschutz-Kram nervt mich unglaublich. Unser externer DSB tut wenig, wird aber fürstlich bezahlt. Ich würde meine Doku gerne selbst machen, mit Formularen kenne ich mich ja aus. 2 h Arbeit im Jahr mit einem einfachen Tool, das die Kosten für den DSB erspart – das wäre toll!&ldquo;
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="d-flex flex-columns" :cols="$mq | mq({lg:4, md:6, sm:12})">
              <v-card grid-list-xl class="mx-auto flex d-flex flex-column">
                <div align="center" style="margin:10px">
                  <v-avatar
                    class="profile"
                    size="164"
                  >
                    <v-img :src="require('@/assets/Markus_Vereinsvorstand_pic.jpg')"></v-img>
                  </v-avatar>
                </div>
                <v-card-title>
                  Markus (59) - Vereinsvorstand
                </v-card-title>
                <v-card-text  class="flex">
                  &bdquo;Mir verdirbt die ganze Angelegenheit die Freude am Ehrenamt, wenn man sich durch einen Dschungel an Verordnungen quälen soll und dabei von vornherein das Gefühl hat, mit einem Bein im Gefängnis zu stehen.&ldquo;
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <router-view></router-view>
    <ImprintFooterView />
  </div>
</template>

<script>

import { listUserdatas } from "../graphql/queries";
import ImprintFooterView from "./ImprintFooterView";


const features = [
    {
        icon:"mdi-file-document-edit",
        title:"VVT gem. Art. 30",
        text:"SODA© dokumentiert alle Verfahren in einem oder mehreren Unternehmen. Die Verfahren sind frei kopier- und anpassbar."
    },
    {
        icon:"mdi-clipboard-check",
        title:"Techn. Org. Maßnahmen (TOM) Art. 32 DSGVO",
        text:"SODA© dokumentiert ebenso alle TOMs in den 9 anerkannten Kategorien. Einfaches Ankreuzen oder Löschen aller gängigen Maßnahmen ermöglicht die Erstellung einer Auflistung in wenigen Minuten. "
    },
    {
        icon:"mdi-file-document-box-multiple",
        title:"Vorlagen für mehrere Branchen",
        text:"Neben der allgemeinen Vorlagen bietet SODA© spezielle VVT und TOM Vorlagen für Ärzte, Steuerberater/Wirtschaftsprüfer und Vereine! Diese beinhalten speziellen Verfahren (bspw. DATEV Module, TI-Infrastruktur, Mitgliederverwaltung)."
    },
    {
        icon:"mdi-shield-check",
        title:"Datenschutzkonzept",
        text:"SODA© generiert ein frei änderbares Datenschutzkonzept nach Vorgaben des Datenschutzmanagments (DSM) für Ihre Unternehmen als Vorschlag. "
    },
    {
        icon:"mdi-file-pdf",
        title:"Export als PDF und XLS",
        text:"SODA© exportiert Ihr VVT und Ihre TOMs als PDF. Die Dateien werden in einem internen Speichersystem mit einem Time-Stamp abgelegt.  "
    },
    {
        icon:"mdi-account-multiple",
        title:"Verwaltung mehrerer Unternehmen",
        text:"Mit SODA© können Sie, je nach Paket mehrere Unternehmen gleichzeitig verwalten. Für Datenschutzbeauftragte bietet sich das „Unlimited“-Paket an. Hier können Sie alle Ihre Mandanten übersichtlich verwalten. "
    },
    {
        icon:"mdi-checkbox-multiple-marked",
        title:"Strukturierte To-Do -Listen",
        text:"SODA© exportiert alle Maßnahmen strukturiert in einer XLS-Tabelle und stellt diese zum Export bereit. "
    },
    {
        icon:"mdi-certificate",
        title:"Rechtliche geprüft und aktuell",
        text:"SODA© Vorlagen werden ständig aktualisiert. Sie passen sich der aktuellen Rechtsprechung und den rechtlichen Erfordernissen der Datenschutzbehörden an und bieten eine gute Richtschnur."
    },
]

export default {
  name: "HomeView",
  components: {
    ImprintFooterView,
  },
  async mounted() {
    this.introVideoURL = await this.$Amplify.Storage.get("media/SODA-3-Verfahren-anlegen-v2.mp4", {level: "public"})
    console.log(this.introVideoURL)
    this.show_main = this.$route.path === "/home";
    this.$Amplify.Auth.currentUserInfo().then((user_info) => {
      if (!user_info) {
        return;
      }
      this.logged_in = true;
      this.user_info = user_info;
      this.username = this.user_info.attributes.email;
      this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(listUserdatas)).then((res) => {
        this.username = res.data.listUserdatas.items[0].fullname;
      });
    });
  },
  methods: {
    to_app() {
      this.$router.push({ path: "/app" });
    },
    to_auth() {
      this.$router.push({ path: "/auth" });
    },
    to_plans() {
      this.$router.push({ path: "/home/plans" });
      this.show_main = false;
    },
    to_home() {
      this.$router.push({ path: "/home" });
      this.show_main = true;
    },
    to_features() {
      this.$router.push({ path: "/home/features" });
      this.show_main = false;
    },
    onLogin() {
      if (this.logged_in) {
        this.$router.push({ path: "/app" });
      } else {
        localStorage.setItem("authViewInitialState", "signIn");
        this.$router.push({ path: "/auth" });
      }
    },
    onSignup() {
      if (this.logged_in) {
        this.$router.push({ path: "/app" });
      } else {
        localStorage.setItem("authViewInitialState", "signUp");
        this.$router.push({ path: "/auth" });
      }
    },
  },
  data: function() {
    return {
      logged_in: false,
      username: null,
      user_info: null,
      show_main: true,
      introVideoURL: null,
      features: features
    };
  },
};
</script>

<style lang="scss" scoped>


.v-card__text, .v-card__title {
  word-break: normal; /* maybe !important  */
}



.intro-video-section {
  background-color:white;
}
.video-player {
  width: 800px;
  bottom:100px;
  margin:30px;
  box-shadow: 0 0 30px;
}
.video-player-sm {
  width: 100%;
  bottom:100px;
  box-shadow: 0 0 20px;
}

.personas-section {
  background-color:var(--v-secondary-base);
  padding-left:10px;
  padding-right:10px;
  padding-bottom:100px;
}

</style>
